import gql from 'graphql-tag';

export const lightUserFragment = gql`
  fragment lightUserFragment on LightUser {
    ID
    name
    handle
    bio
    following
    followers

    ifollow
    followsYou

    friends
    photoURL
  }
`;
